// @ts-strict-ignore
import { Injectable } from '@angular/core';
import { LabelEditorMode } from '../../label/label-editor/label-editor.component';
import { ArrayUtils } from '@shared/util/array-utils';
import { LabelEditorStateManager } from '../../label/label-editor/service/label-editor-state.manager';
import { SelectionModelService } from './selection-model.service';
import { SelectionModel } from '../model/selection.model';
import { MetaElementUsageIdentityVO, SelectionMetaElementUsageIdentity } from '@shared/vo/meta-element.vo';
import { Connection } from '@3d-scene/model3d/connection';
import { TextureConnectionUtils } from '@3d-scene/processor/texture-connection-utils';

interface ChangeObjectSelectionData {
  objectId: any;
  ctrlClamped: boolean;
  shiftClamped: boolean;
  isObjectSelected: boolean;
}

@Injectable({ providedIn: 'root' })
export class ProjectLabelEditorSelectionModelService {

  private _delayedChangeObjectSelection: ChangeObjectSelectionData = null;

  constructor(private selectionModel: SelectionModel,
              private selectionModelService: SelectionModelService,
              private labelEditorStateManager: LabelEditorStateManager,
              private textureConnectionUtils: TextureConnectionUtils) {
  }

  public changeObjectSelectionOnClick(objectId: any, ctrlClamped: boolean, shiftClamped: boolean, isObjectSelected: boolean): void {
    if (!objectId || !this.selectionModelService.isSelectionEnabled()) {
      return;
    }
    if (this.labelEditorStateManager.labelEditorMode === LabelEditorMode.APPLYING_CHANGES) {
      this._delayedChangeObjectSelection = { objectId, ctrlClamped, shiftClamped, isObjectSelected };
      return;
    }
    const isTextConnectionsSelected: boolean = ArrayUtils.isNotEmpty(this.selectionModelService.getTextConnections());
    if (ctrlClamped || shiftClamped || this.selectionModel.selectedObjects.length <= 1) {
      if (isObjectSelected) {
        this.selectionModelService.unSelectObject(objectId);
      } else {
        this.selectionModelService.selectObject(objectId, ctrlClamped, shiftClamped, isTextConnectionsSelected);
      }
    } else {
      this.selectionModelService.removeAllSelections();
      this.selectionModelService.selectObject(objectId, ctrlClamped, shiftClamped, isTextConnectionsSelected);
    }
  }

  public labelEditorModeChanged(mode: LabelEditorMode): void {
    if (mode === LabelEditorMode.EDITING && this._delayedChangeObjectSelection) {
      if (this._delayedChangeObjectSelection.objectId instanceof MetaElementUsageIdentityVO) {
        const relatedTextureCube: Connection = this.textureConnectionUtils.findTextureConnectionCubeByRelativeAcceptingAreaId(
          this._delayedChangeObjectSelection.objectId
        );
        if (relatedTextureCube) {
          this._delayedChangeObjectSelection.objectId = new SelectionMetaElementUsageIdentity(
            relatedTextureCube.articleContainer.articleGUID,
            relatedTextureCube
          );
        }
      }
      this.changeObjectSelectionOnClick(
        this._delayedChangeObjectSelection.objectId,
        this._delayedChangeObjectSelection.ctrlClamped,
        this._delayedChangeObjectSelection.shiftClamped,
        this._delayedChangeObjectSelection.isObjectSelected
      );
    }
    this._delayedChangeObjectSelection = null;
  }
}
